import { Navigate, generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { NBA_SCOUTING_CENTER } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { Playoffs } from 'components/PlayOffs';

const Wrapper = styled.div`
  margin: var(--double-unit) 0;
  @media ${tabletAndAbove} {
    margin: var(--double-unit);
  }
`;

const PlayoffsPage = () => {
  const {
    flags: { nbaPlayoffsConfig = undefined },
  } = useFeatureFlags();

  if (Object.keys(nbaPlayoffsConfig).length === 0) {
    return <Navigate to={generatePath(NBA_SCOUTING_CENTER)} />;
  }
  return (
    <Wrapper>
      <PageHeader text={scoutingCenter.scout} disableBackBrowser />
      <Playoffs />
    </Wrapper>
  );
};

export default PlayoffsPage;
